import { useEffect } from 'react';
import { suscribirseALaSesion } from '../lib/sesion.js';
import { intentarElEnvio } from './cola.js';

/**
 * El vaciado de la cola, montado en toda la app (H-1, P-132).
 *
 * No dibuja nada: existe para que **no importe en qué pantalla esté** el
 * paciente. La regla es una sola y vive en `intentarElEnvio`: con sesión y con
 * algo guardado, se intenta enviar. Acá sólo están los momentos en que la app se
 * entera de que eso puede haber cambiado:
 *
 *   - **Al abrir la app**, por si ya había sesión en la pestaña.
 *   - **Cada vez que aparece una sesión**: el canje de un enlace, la renovación
 *     silenciosa ante un 401 y, sobre todo, **la entrada con el teléfono
 *     recordado**. Es como vuelve quien respondió sin señal y cerró la app
 *     (INGRESO-1), y era el camino que faltaba (P-132): al montar todavía no
 *     había sesión, y nadie volvía a mirar cuando llegaba.
 *   - **Al recuperar la conexión**, con la app abierta en cualquier lado.
 *
 * **Acá no hay ninguna consecuencia escrita.** Recargar lo que el servidor dice
 * del paciente después de que algo sale de la cola es parte del vaciado y vive
 * con él (`cola.ts`): vale igual para todos los momentos.
 */
export function VaciadoDeLaCola() {
  useEffect(() => {
    const intentar = () => {
      void intentarElEnvio();
    };

    intentar();
    const dejarDeEscuchar = suscribirseALaSesion(intentar);
    window.addEventListener('online', intentar);
    return () => {
      dejarDeEscuchar();
      window.removeEventListener('online', intentar);
    };
  }, []);

  return null;
}
